import {appEnv} from '@/appEnv'
import {getLoggingHttpHeaders} from '@repo/shared/Customer/Coop/utils/backendLogging'
import axios from 'axios'
import {getAverageDataForToday} from './singleMode/getAverageDataForToday'
import {registerUser} from './singleMode/registerUser'

export const api = {
  singleMode: {
    getAverageDataForToday,
    registerUser,
  },
}

axios.interceptors.request.use(config => {
  const extraHeaders = getLoggingHttpHeaders({version: appEnv.VERSION})

  extraHeaders.forEach(({key, value}) => config.headers.set(key, value))

  return config
})
